<template>
<div class="lesson" :style="{paddingTop: headerHeight + 'px'}" v-loading="pageLoading">
  <SubHeader :showUser="true"  :showNav="false"></SubHeader>
  <div class="box-line" id="line"></div>
  <div class="lesson-content" style="width: 100%;">
    <van-tabs tab-class="item" :ellipsis="false" tab-active-class="active" class="type-select" v-model="classify" @change="getList">
      <template v-for="(item,index) of category">
        <van-tab :title="item.name" :key="index"></van-tab>
      </template>
    </van-tabs>
    <van-list v-loading="listLoading" v-if="list.length" v-model="loading" :finished="finished" finished-text="没有更多了">
      <div class="hot-list">
        <MediaCard v-for="item of list" :key="item.id" @click.native="jumpLiveDetail(item)" :cardData="item"></MediaCard>
      </div>
    </van-list>
    <van-empty style="margin: 0 auto" v-if="!list.length" description="暂无数据" />
  </div>
</div>
</template>

<script>
import PriceCard from "@/components/PriceCard";
import VideoCard from "@/components/VideoCard";
import MediaCard from "@/components/MediaCard";
import SubHeader from "@/components/SubHeader";
export default {
  name: "lesson",
  components: {
    PriceCard,
    VideoCard,
    MediaCard,
    SubHeader,
  },
  data() {
    return {
      active: 0,
      list: [],
      tag: 1,
      classify: 0,
      certificate: [],
      topData: [],
      category: [],
      loading: false,
      pageLoading: true,
      finished: true,
      more: false,
      ideaNavData: [],
      ideaAllData: [],
      listLoading: false,
    };
  },
  async mounted() {
    window.addEventListener("scroll", this.onLoad);
    this.getData();
    let res = await this.$api({
      method: "get",
      host: "https://saas.amfakids.cn",
      url: "/api/v1/short/video/hotvideo",
    });
    if (res.code == 200) {
      this.topData = res.data.video_arr;
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.onLoad);
  },
  computed: {
    plat() {
      return this.$store.state.plat_id;
    },
    headerHeight() {
      return this.$store.state.headerHeight;
    }
  },
  methods: {
    getTag(index) {
      this.tag = index;
    },
    async getList(index) {
      this.listLoading = true;
      this.classify = index;
      let res = await this.$api({
        method: "get",
        host: "https://saas.amfakids.cn",
        url: "/api/v1/short/video",
        data: {
          category_id: this.category[this.classify].id,
          service_id: this.plat == 119 ? 2 : 1,
          form: 2,
          page: 1,
          limit: 1000,
        },
      });
      this.listLoading = false;
      if (res.code == 200) {
        this.list = res.data.video_arr;
      } else {
        this.$toast(res.msg);
      }
    },
    jumpLiveDetail(item) {
      let {
        name,
        url,
        cover_url,
        id
      } = item;
      this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${url}&cover=${cover_url}`);
    },
    async getData() {
      this.pageLoading = true;
      let res = await this.$api({
        method: "get",
        host: "https://saas.amfakids.cn",
        url: "/api/v1/short/video",
        data: {
          category_id: 0,
          service_id: this.plat == 119 ? 2 : 1,
          form: 2,
          page: 1,
          limit: 1000,
        },
      });
      this.pageLoading = false;
      if (res.code == 200) {
        this.category = res.data.category_arr;
        this.list = res.data.video_arr;
      } else {
        this.$toast(res.msg);
      }
    },
    getMore() {
      if (this.more) {
        return;
      }
      this.more = true;
      if (this.menu == 2) {
        axios
          .get(
            `/api/platform/pc/category?flat_id=${this.plat}&page=${this.page}`, {}
          )
          .then((res) => {
            this.more = false;
            console.log(res);
            if (res.code == 0) {
              let list = res.data.category[this.classify].goods;
              this.list = this.list.concat(list);
              this.loading = false;
              if (list.length < 10) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            } else {
              this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
            this.more = false;
          });
      }
    },
  },
  beforeRouteUpdate(to, from, next) {
    console.log("beforeRouteUpdate");
    console.log(this);
    next();
  },
};
</script>

<style lang="scss" scoped>
.lesson {
  min-height: calc(100vh - 230px);
  display: flex;
  align-items: flex-start;
  overflow: hidden;

  .hot-list {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0 30px;
  }
}
</style>

<style lang="scss">
</style>
